/**
 * User State Synchronization Utility
 *
 * This utility enables communication between different Redux stores
 * that manage user state independently. It uses CustomEvents to broadcast
 * and listen for user state changes across different parts of the application.
 *
 * This is currently being used to sync the TopNav store and the Gallery Store
 */

export interface UserData {
  userId: string;
  userName: string;
  subscriptionPlanName?: string;
  email?: string;
  avatarDisk?: string;
  imgUrl?: string;
  initials?: string;
  firstName?: string;
}

const USER_STATE_CHANGED_EVENT = 'user-state-changed';

export const broadcastUserStateChange = (userData: UserData): void => {
  const event = new CustomEvent(USER_STATE_CHANGED_EVENT, {
    detail: userData,
  });
  window.dispatchEvent(event);
};

export const subscribeToUserStateChanges = (
  callback: (userData: UserData) => void
): (() => void) => {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<UserData>;
    callback(customEvent.detail);
  };

  window.addEventListener(USER_STATE_CHANGED_EVENT, handler);

  return () => {
    window.removeEventListener(USER_STATE_CHANGED_EVENT, handler);
  };
};
